export const GET_BANNERS_DATA = '[BANNERS] GET_BANNERS_DATA';
